import { Record as record } from 'immutable';

import { getDefaults, getResolvers } from '../../../../helpers/Records';
import { construct, resolve, resolveAll } from '../../../../helpers/LinkMapper';

import Journey from './Journey';
import { IBlocksTransitModes } from "../../../../constants/AppConstants";
import trainTime from '../../../../lib/TrainTime';

const fieldSchema = {
    "ticketId": [resolve.with(Number)],
    "description": [resolve.with(String)],
    "destinationCode": [resolve.with(String)],
    "destinationName": [resolve.with(String)],
    "fare": [resolve.with(Number)],
    "fulfilmentType": [resolve.with(String)],
    "journeys": [resolveAll.as(Journey)],
    "originalFare": [resolve.with(Number)],
    "originCode": [resolve.with(String)],
    "originName": [resolve.with(String)],
    "railcard": [resolve.with(String)],
    "reasonCode": [resolve.with(String)],
    "saleType": [resolve.with(String)],
    "ticketCategory": [resolve.with(String)],
    "transitMode": [resolve.with(String)],
    "validityEndDate": [resolve.with(trainTime)],
    "validityStartDate": [resolve.with(trainTime)],
};

class Ticket extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(Ticket, json, getResolvers(fieldSchema));
    }

    isBus() {
        return this.transitMode.toUpperCase() === IBlocksTransitModes.BUS;
    }

    isSmartCarnet() {
        return (
            this.fulfilmentType && this.fulfilmentType.toUpperCase().trim() === 'CLOUD' &&
            this.saleType.toUpperCase().trim() === 'PREPAID' &&
            this.ticketCategory.toUpperCase().trim() === 'FLEXI_PASS'
        );
    }

    isSmartCarnetOffPeak() {
        return this.description.toLowerCase().includes('off');
    }
}

export default Ticket;



// WEBPACK FOOTER //
// ./src/records/customer/keygo/journeyHistory/Ticket.js